export default __webpack_public_path__ + "static/media/multiasset-banner-mob-invest.263e56ed.jpg";